import { Component } from "@angular/core";

@Component({
  selector: 'app-disabled-feature',
  templateUrl: './disabled-feature.component.html',
  styleUrls: []
})

export class DisabledFeatureComponent { }